import { 
  getFirestore, 
  collection, 
  query, 
  where, 
  onSnapshot, 
  updateDoc, 
  doc, 
  getDoc, 
  DocumentData, 
  arrayUnion 
} from 'firebase/firestore';

export const listenForReferralVerification = (
  referrerId: string,
  setReferralBalance: React.Dispatch<React.SetStateAction<number>>
) => {
  const db = getFirestore();

  // Query for users who were referred by the referrer
  const friendsQuery = query(collection(db, 'users'), where('referredBy', '==', referrerId));

  console.log(`Listening for friends referred by referrer: ${referrerId}`);

  return onSnapshot(friendsQuery, async (querySnapshot) => {
    querySnapshot.forEach(async (docSnapshot) => {
      const friendData = docSnapshot.data() as DocumentData;

      console.log('Friend Data:', friendData);

      // Ensure friend's status is verified and reward has not been credited yet
      if (friendData.status === 'verified' && !friendData.rewardCredited) {
        console.log(`Friend ${docSnapshot.id} is verified and reward has not been credited. Processing...`);

        // Access the deposit map and retrieve the amount
        const depositData = friendData.deposit || {};
        const depositAmount = depositData.amount || 0; // Default to 0 if amount is missing

        // Determine referral commission based on the deposit amount
        let referralCommission = 0;
        if (depositAmount === 2500) {
          referralCommission = 500;
        } else if (depositAmount === 7000) {
          referralCommission = 2000;
        } else if (depositAmount === 12000) {
          referralCommission = 4000;
        }else if (depositAmount === 25000){
          referralCommission = 8000;
        }

        // If a valid referral commission is determined, proceed to update
        if (referralCommission > 0) {
          const referrerDocRef = doc(db, 'users', referrerId);
          const referrerDocSnap = await getDoc(referrerDocRef);

          if (referrerDocSnap.exists()) {
            const referrerData = referrerDocSnap.data();

            const currentReferralBalance = referrerData?.referralBalance || 0;
            const newReferralBalance = currentReferralBalance + referralCommission;

            console.log(`Updated referral balance for ${referrerId}: ${newReferralBalance}`);

            // Update the referrer's referral balance
            await updateDoc(referrerDocRef, {
              referralBalance: newReferralBalance,
              referrals: arrayUnion({ friendId: docSnapshot.id, depositAmount }), // Add friend and deposit to referrals
              referredFriends: arrayUnion(docSnapshot.id) // Add the friend's ID to referredFriends field
            });

            // Update the state for referral balance
            setReferralBalance(newReferralBalance);

            // Mark the reward as credited in the friend's document
            const friendDocRef = doc(db, 'users', docSnapshot.id);
            await updateDoc(friendDocRef, {
              rewardCredited: true,
            });

            console.log(`Referral reward of ${referralCommission} credited for friend ${docSnapshot.id}.`);
          } else {
            console.error(`Referrer document does not exist: ${referrerId}`);
          }
        } else {
          console.warn(`No valid referral commission for deposit amount: ${depositAmount}`);
        }
      } else {
        // Add the friend to referredFriends even if they are not verified
        const referrerDocRef = doc(db, 'users', referrerId);
        await updateDoc(referrerDocRef, {
          referredFriends: arrayUnion(docSnapshot.id), // Add the friend's ID even if not verified
        });

        console.log(`Friend ${docSnapshot.id} added to referredFriends for referrer ${referrerId}.`);

        if (friendData.rewardCredited) {
          console.log(`Friend ${docSnapshot.id} has already credited the reward to referrer.`);
        } else {
          console.log(`Friend ${docSnapshot.id} is not verified yet.`);
        }
      }
    });
  });
};
